import React, { ReactNode } from 'react'
import { HelpCircle } from '../../utils/icons'

import { Navigation, NavBrand, NavIconButton } from 'prosci-ui'
import {
  APP_IMAGE_MAPPING,
  CONTACT_LINK,
} from '../../config';
import {
  useAppCopy,
} from '../../hooks';

interface NavigationLayoutPublicProps {
  children: ReactNode
}

// Layout component that wraps all view components.
function NavigationLayoutPublic({
  children,
}: NavigationLayoutPublicProps) {
  const appCopy = useAppCopy();

  return (
    <>
      <Navigation brand={<NavBrand icon={<img src={APP_IMAGE_MAPPING['portal']} alt="Prosci" className="h-6 w-6" />} name="Prosci Portal" href="/" />}>
        <NavIconButton
          label={appCopy('help')}
          href={CONTACT_LINK}
          target="_blank"
          rel="noopener noreferrer"
          icon={<HelpCircle className="h-5 w-5" />}
        />
      </Navigation>
      {children}
    </>
  );
}


export default NavigationLayoutPublic
